import { GenericElement } from '@agilelab/plugin-wb-platform';
import { CatalogApi } from '@backstage/plugin-catalog-react';
import { createContext, Provider, useContext } from 'react';
import { DomainHandlerProvider } from './providers/DomainHandlerProvider';
import { SystemHandlerProvider } from './providers/SystemHandlerProvider';
import {
  MyProvider,
  ProviderFilters,
  ScopeEnum,
  ScopeProviderType,
} from './types';
import { SystemTypeHandlerProvider } from './providers/SystemTypeHandlerProvider';

export const entityHandler = (catalogApi: CatalogApi) =>
  new Map<string, MyProvider<GenericElement, ProviderFilters>>([
    [ScopeEnum.system, new SystemHandlerProvider(catalogApi)],
    [ScopeEnum.domain, new DomainHandlerProvider(catalogApi)],
    [ScopeEnum.systemType, new SystemTypeHandlerProvider(catalogApi)],
  ]);

export function contextProviderFactory<
  T extends ScopeProviderType<GenericElement, ProviderFilters>,
>(): [() => T, Provider<T | undefined>] {
  const context = createContext<T | undefined>(undefined);

  const useProvider = () => {
    const c = useContext(context);

    if (c === undefined) {
      throw new Error(
        'The hook "useProvider" must be used within an existing context.',
      );
    }

    return c;
  };

  return [useProvider, context.Provider];
}
